import React, {Component} from 'react';
import {connect} from 'react-redux';
import {classNamesPrefixed} from "../helpers/CoreHelpers";
import InputWrap from "../admin/components/Fields/InputWrap";
import axios from "axios";
import Config from "../config";

const validation = {
    'required': (value) => {
        if (!value) {
            return "Field is required"
        }
        return undefined;
    },
    'number': (value) => {
        if (isNaN(value)) {
            return "Value should be number"
        }
        return undefined;
    }
}

class GlobalFieldSelectModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fields: null,
            messages: {
                submitting: (props.messages && props.messages.submitting) ? props.messages.submitting : "Sending the data...",
                success: (props.messages && props.messages.success) ? props.messages.success : "Thank you, your submission is registred.",
                error: (props.messages && props.messages.error) ? props.messages.error : "Sorry, we could not send the data, please try later again.",
            },
            valid: true,
            submitting: false,
            submitted: false,
            error: false,
            success: false,
            pristine: true,
            values: {},
            errors: {},
            warnings: {},
            touched: {},
            validateOnBlur: props.validateOnBlur ? props.validateOnBlur : true,
            validateOnChange: props.validateOnChage ? props.validateOnChage : false,
            validateOnFocus: props.validateOnFocus ? props.validateOnFocus : false,
        };

        if (props.user.isLoggedIn) {
            this.state.values = {
                nameSurname: `${props.user.given_name} ${props.user.family_name}`
            }
        }

        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.clearForm = this.clearForm.bind(this);
    }

    componentDidMount() {
        const {fields} = this.state;
        if (!fields) {
            this.getFormFields();
        }
    }

    getFormFields() {
        this.setState({
            fields: this.props.fields,
        })
    }

    clearForm() {
        this.setState({
            valid: true,
            submitting: false,
            error: false,
            pristine: true,
            values: {},
            errors: {},
            warnings: {},
            touched: {},
        })
    }

    onSubmit(e) {
        e.preventDefault();
        const {values, valid, pristine, submitting} = this.state;
        const {id} = this.props;

        if (!valid || pristine || submitting) return false;

        const url = Config.api.endpoint + "api/Content/formdata";

        let postData = {
            "contentId": id,
            data: JSON.stringify(values)
        };

        this.setState({
            submitting: true,
        });

        let setState = this.setState.bind(this);
        let clearForm = this.clearForm.bind(this);

        axios.post(url, postData, Config.getApiConfig()).then(function (response) {

            if (response.status === 200) {
                setState({
                    submitting: false,
                    success: true,
                    submitted: true,
                })
                clearForm();
            } else {
                setState({
                    submitting: false,
                    success: false,
                    error: true
                })
            }

        }).catch(function (error) {
            setState({
                submitting: false,
                error: true,
            })
        });

    }


    getFormField(field, index) {
        const {id} = this.props;
        const {valid, pristine, submitting} = this.state;
        let fieldComponent = null;
        switch (field.type) {
            case "submit":
                fieldComponent = (
                    <button key={`${id}-${field.type}-${index}`} disabled={!valid || pristine || submitting} type="submit">{field.label}</button>
                );
                break;

            default:
                fieldComponent = (
                    <InputWrap key={`${id}-${field.type}-${index}`} {...field}>
                        <input
                            type={field.type}
                            name={field.name ? field.name : field.id}
                            id={id + "_" + field.id} //form id + field id
                            placeholder={field.placeholder}
                            value={field.value}
                            onChange={(e) => this.onChange(e, field)}
                            onFocus={(e) => this.onFocus(e, field)}
                            onBlur={(e) => this.onBlur(e, field)}
                        />
                    </InputWrap>
                )
                break;
        }

        return fieldComponent
    }

    validate(value, field) {
        const {errors} = this.state;
        const fieldsWithErrors = Object.keys(errors);
        let result = undefined;
        for (let x in field.validate) {
            result = validation[field.validate[x]](value);
            if (typeof (result) !== "undefined") {
                errors[field.name] = result;
                this.setState({
                    errors: errors,
                    valid: false,
                });
                return;
            }
        }
        if (typeof (result) === "undefined") {
            errors[field.name] = undefined;
            let valid = true;
            for (let y in fieldsWithErrors) {
                if (typeof (errors[fieldsWithErrors[y]]) !== "undefined") {
                    valid = false;
                }
            }
            if (valid !== this.state.valid) {
                this.setState({
                    valid: valid,
                });
            }
        }
    }


    onChange(e, field) {
        const {values, validateOnChange} = this.state;
        const {name} = field;
        if (e && e.target && typeof (e.target.value) !== "undefined") {
            if (e.target.value !== values[name]) {
                values[name] = e.target.value;
                this.setState({
                    values: values,
                    pristine: false,
                });
                if (validateOnChange) {
                    this.validate(e.target.value, field);
                }
            }
        }
    }

    onFocus(e, field) {
        const {validateOnFocus, touched, values} = this.state;
        if (validateOnFocus) {
            if (values && typeof (values[field.name]) !== "undefined") {
                this.validate(values[field.name], field);
            }
        }
        if (!touched[field.name]) {
            touched[field.name] = true
            this.setState({
                touched: touched
            });
        }
    }

    onBlur(e, field) {
        const {validateOnBlur, values, touched} = this.state;
        if (validateOnBlur) {
            if (values && (typeof (values[field.name]) !== "undefined" || touched[field.name])) {
                this.validate(values[field.name], field);
            }
        }
    }

    render() {
        const {id} = this.props;
        const {fields, values, errors, warnings, submitting, error, success, messages} = this.state;

        if (!fields) return null;

        return (
            <div className={classNamesPrefixed({
                'public-form': true,
                ['public-form-' + id]: true
            })}>

                {submitting &&
                <p className={"form-message"}>{messages.submitting}</p>
                }

                {!submitting && error &&
                <p className={"form-message"}>{messages.error}</p>
                }

                {success &&
                <p className={"form-message"}>{messages.success}</p>
                }

                {!success &&
                <form id={id} name={id} onSubmit={this.onSubmit}>
                    {fields.map((field, index) => {

                        field.value = values[field.name] ? values[field.name] : "";
                        field.error = errors[field.name];
                        field.warning = warnings[field.name];

                        return this.getFormField(field, index)

                    })}
                </form>
                }

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        globals: state.global.items
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalFieldSelectModal)


// WEBPACK FOOTER //
// ./src/core/components/PublicForm.js